import React from "react";
import "./../styles/variable-projects.css";
import Projectsvariable from "../components/variable-projects";
import imagem1 from '../assets/images/Projetos/Aeroporto/aeroporto.jpg';
import imagem2 from '../assets/images/Projetos/Aeroporto/aeroporto-img2.jpg';
import imagem3 from '../assets/images/Projetos/Aeroporto/aeroporto-img3.jpg';

const App = () => {
  const projectData = {
    date: "26/03/2018",
    title: "Aeroporto RIOgaleão",
    images: [
      imagem1,
      imagem2,
      imagem3
    ],
    description:
      "Um dos principais aeroporto do país, com prioridade alta em todos os serviços, atuamos no GIG – RIOgaleão com:",
    solutions: ["Sistema Irradiante"],
  };

  return <Projectsvariable {...projectData} />;
};

export default App;